module.exports = __webpack_public_path__ + "static/media/Rapport4.3deb66ad.png";